module.exports = __webpack_public_path__ + "ptsans.aa77ada5.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/src/assets/fonts/ptsans/ptsans.ttf
// module id = 2382
// module chunks = 0